import gql from "graphql-tag";

export const BOOKING_GET_CHECKLISTS_FOR_EQUIPMENTS = gql`
  query GetChecklistsForEquipments($keys: [String!]!) {
    getChecklistsForEquipments(keys: $keys) {
      key
      checklists {
        url
        description
      }
    }
  }
`;

export const GET_CHECKLIST_FOR_EQUIPMENT = gql`
  query getChecklistsForEquipment($input: GetChecklistsForEquipmentInput) {
    getChecklistsForEquipment(input: $input) {
      items {
        url
        description
      }
    }
  }
`;

export const LIST_DIGITAL_LAB_BOOKING_INSTRUMENTS = gql`
  query listDigitalLabBookingInstruments(
    $inventoryId: String
    $siteName: String
    $filter: ModelDigitalLabBookingInstrumentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDigitalLabBookingInstruments(
      siteName: $siteName
      inventoryId: $inventoryId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        inventoryId
        entryType
        modelName
        secondaryID
        secondaryIDMapping
        controlledEquipmentStatus
        linkedInstance
        siteName
        serialNumber
        materialNumber
        inventoryNumber
        equipmentId
        instrumentRUDI
        instrumentGTIN
        isBookable
        equipmentCategory
        manufacturer
        equipmentModel
        entryType
        variant
        cluster
        clusterId
        equipmentNickName
        comment
        belongingToGroup
        buildingLocation {
          key
          value
        }
        floor {
          key
          value
        }
        room {
          key
          value
        }
        responsiblePerson
        systemOwner
        status
        responsibleProxy
        functionalLocation
        costCenter
        sop {
          key
          value
        }
        gxpRelevant
        qualificationStatus
        dateOfLastMaintanance
        dateOfNextMaintanance
        displayQualificationStatus
        qualificationDocuments {
          isSynchronized
          value {
            name
            documentId
          }
        }
        softwareVersion
        configurationBaseline
        configurationDetails
        vnvStatus
        installedTests {
          name
          version
        }
        isBookable
        isVisualized
        systemStatus
        siteId
        siteTimezone
        location
        displayImage
        createdBy
        updatedBy
        status
        datamodelVersion
        shortIdentifier
        addInfoId
        createdAt
        updatedAt
        addInfo {
          id
          inventoryId
          instrumentStatus
          instrumentAvailability
          bookedBy
          bookedByEmail
          isBookingControlled
          bookableForUsers
        }
      }
      nextToken
    }
  }
`;
export const LIST_DIGITAL_LAB_BOOKING_INSTRUMENTS_IDS = gql`
query listDigitalLabBookingInstruments(
  $inventoryId: String
  $filter: ModelDigitalLabBookingInstrumentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDigitalLabBookingInstruments(
    inventoryId: $inventoryId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      inventoryId
    }
    nextToken
  }
}`;
export const LIST_BOOKING_COMMAND = gql`
  query listBookingCommands {
    listBookingCommands(limit: 1) {
      items {
        id
        entries {
          dateFrom
          dateTo
          inventoryId
          processingResult
        }
      }
    }
  }
`;

export const LIST_BACKEND_HEALTH_CHECKS = gql`
  query listBackendHealthChecks {
    listBackendHealthChecks {
      items {
        id
        moduleName
        moduleVersion
        ciJobId
        commitHash
        enableAnalyticsTracking
        createdAt
        updatedAt
      }
    }
  }
`;

export const LIST_DIGITAL_LAB_BOOKING_USERS = gql`
  query listDigitalLabBookingUsers($limit: Int, $nextToken: String) {
    listDigitalLabBookingUsers(limit: $limit, nextToken: $nextToken) {
      items {
        userId
        email
        familyName
        givenName
        name
      }
      nextToken
    }
  }
`;

export const LIST_DIGITAL_LAB_BOOKING_USER_PROFILES = gql`
  query listDigitalLabBookingUserProfiles($limit: Int, $nextToken: String) {
    listDigitalLabBookingUserProfiles(limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        familyName
        givenName
        name
        user
      }
      nextToken
    }
  }
`;

// Resolves a CIDM group name to its full membership, matched against booking users.
export const GET_CIDM_GROUPS = gql`
  query GetCidmGroups($input: GetCidmGroupsInput!) {
    getCidmGroups(input: $input) {
      userId
      email
      givenName
      familyName
      name
    }
  }
`;

export const BOOKING_BY_SITE_AND_DATE = gql`
  query BookingBySiteAndDate(
    $site: String
    $dateRange: [String]
    $limit: Int
    $nextToken: String
    $filter: ModelBookingFilterInput
    $sortDirection: ModelSortDirection
  ) {
    bookingBySiteAndDate(
      site: $site
      date: { between: $dateRange }
      limit: $limit
      nextToken: $nextToken
      filter: $filter
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        createdBy
        createdByEmail
        date
        dateFrom
        dateTo
        description
        richDescription
        remark

        project
        redPandaProjects {
          themeNumber
          projectShortName
          projectName
          projectId
        }
        type
        active
        bookingEntries {
          items {
            isFirstTimeUser
            active
            allDay
            bookingId
            color
            createdAt
            createdBy
            createdByEmail
            date
            description
            richDescription
            isFirstTimeUser
            end
            equipment {
              belongingToGroup
              addInfoId
              cluster
              clusterId
              comment
              equipmentId
              entryType
              equipmentModel
              equipmentNickName
              equipmentCategory
              inventoryId
              isVisualized
              location
              responsibleProxy
              responsiblePerson
              siteName
              serialNumber
              shortIdentifier
              softwareVersion
            }
            reservedForEmails
            reservedForUsers
            site
            start
            timezone
          }
        }
      }
      nextToken
    }
  }
`;
export const GET_BOOKING_DATA_BY_SITE = gql`
  query getBookingDataBySite($site: String, $limit: Int, $nextToken: String, $filter: String, $dateFrom: String) {
    getBookingDataBySite(site: $site, limit: $limit, nextToken: $nextToken, filter: $filter, dateFrom: $dateFrom) {
      items {
        bookedEquipments
        bookedUsers {
          email
          familyName
          givenName
          name
          user
        }
        bookingEntries {
          isFirstTimeUser
          active
          allDay
          bookedSlots
          bookingId
          color
          start
          end
          fcolor
          id
          type
          equipment {
            softwareVersion
            shortIdentifier
            serialNumber
            location
            equipmentNickName
            equipmentModel
            equipmentId
            belongingToGroup
            equipmentModel
            softwareVersion
            siteName
            manufacturer
            variant
            materialNumber
            responsiblePerson
            systemStatus
            configurationBaseline
            equipmentCategory
            entryType
            qualificationStatus
          }
          inventoryId
          reservedForUsers
        }
        assistent
        assistentTime
        approval {
          approvedBy
          approvedByEmail
          approvedDate
          rejectionReason
          status
        }
        hazardousDeclaration {
          hasHazardousMaterials
          hazardousMaterialsList
        }
        assistanceDeclaration {
          requiresAssistance
          assistanceReason
        }
        id
        project
        redPandaProjects {
          themeNumber
          projectShortName
          projectName
          projectId
        }
        description
        richDescription
        elnId {
          name
          eid
          modifiedAt
          objectType
          owner
          state
          type
        }
        type
        date
        dateFrom
        dateTo
        active
        createdBy
        createdAt
        remark
        checkInRequired
        checkInDone
        checkInStartsAt
        checkInEndsAt
        repetitionPattern
      }
      nextToken
    }
  }
`;
export const GET_BOOKING_DATA_BY_SITE_LIGHT = gql`
  query getBookingDataBySite($site: String, $limit: Int, $nextToken: String, $filter: String, $dateFrom: String) {
    getBookingDataBySite(site: $site, limit: $limit, nextToken: $nextToken, filter: $filter, dateFrom: $dateFrom) {
      items {
        bookedEquipments
        bookedUsers {
          email
          familyName
          givenName
          name
          user
        }
        bookingEntries {
          start
          end
          inventoryId
          bookingId
        }
        approval {
          status
        }
        id
        project
        redPandaProjects {
          themeNumber
          projectShortName
          projectName
          projectId
        }
        description
        richDescription
        type
        dateFrom
        dateTo
        active
        checkInRequired
      }
      nextToken
    }
  }
`;
export const GET_BOOKING_ROWS_BY_SITE_NONE = gql`
  query getBookingRowsBySiteNone($site: String!, $date: ModelStringKeyConditionInput, $filter: String, $limit: Int, $nextToken: String) {
    getBookingRowsBySiteNone(site: $site, date: $date, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        dateFrom
        dateTo
        type
        active
        project
        description
        richDescription
        checkInRequired
        reservedForUsers
        reservedForEmails
        assistent
        bookedEquipments
        createdBy
      }
      nextToken
    }
  }
`;
export const FIND_BOOKABLE_INSTRUMENTS = gql`
  query findBookableInstruments(
    $startDate: String!
    $endDate: String!
    $inventoryIds: [String]!
    $siteTimezone: String!
  ) {
    findBookableInstruments(
      startDate: $startDate
      endDate: $endDate
      inventoryIds: $inventoryIds
      siteTimezone: $siteTimezone
    ) {
      items {
        availability
        date
      }
    }
  }
`;

export const LIST_BOOKING_NOTIFICATION_COMMANDS = gql`
  query listBookingNotificationCommands {
    listBookingNotificationCommands(limit: 1) {
      items {
        id
        materialNumber
        serialNumber
        secondaryID
        secondaryIDMapping
        inventoryId
        site
        body
        dateFrom
        dateTo
        createdBy
        createdByEmail
        status
      }
    }
  }
`;

export const LIST_CONFIGURATION_BY__MODEL_AND_CREATED_DATE_DROPDOWN = gql`
  query configurationByModelAndText {
    configurationByModelAndText(modelName: "BOOKINGCANCELREASON", sortDirection: ASC) {
      nextToken
      items {
        id
        configText
      }
    }
  }
`;

export const LIST_CONFIGURATION_BY__MODEL_AND_CREATED_DATE = gql`
  query configurationByModelAndCreatedDate(
    $limit: Int
    $nextToken: String
    $filter: ModelBookingConfigurableMasterFilterInput
  ) {
    configurationByModelAndCreatedDate(
      sortDirection: DESC
      modelName: "BOOKINGCANCELREASON"
      limit: $limit
      filter: $filter
      nextToken: $nextToken
    ) {
      nextToken
      items {
        id
        configText
      }
    }
  }
`;

export const LIST_FILTERBOOKING_DATA_BY_SITE_NAME_AND_FILTER_ATTRIBUTES = gql`
  query listFilterBookingDataBySiteNameAndFilterAttributes(
    $limit: Int
    $nextToken: String
    $siteName: String
    $filterAttribute: ModelStringKeyConditionInput
  ) {
    listFilterBookingDataBySiteNameAndFilterAttributes(
      limit: $limit
      nextToken: $nextToken
      siteName: $siteName
      filterAttribute: $filterAttribute
    ) {
      items {
        filterAttribute
        filterValue
      }
      nextToken
    }
  }
`;

export const LIST_BOOKING_ACCESS_CONFIGURATION = gql`
  query listBookingAccessConfigurations($limit: Int, $nextToken: String) {
    listBookingAccessConfigurations(limit: $limit, nextToken: $nextToken) {
      items {
        modelName
        groupName
        id
      }
      nextToken
    }
  }
`;
export const LIST_BOOKING_GROUP_CONFIGURATION_BY_CREATE_DATE = gql`
  query listBookingGroupConfigurationByCreatedDate(
    $limit: Int
    $nextToken: String
    $filter: ModelBookingGroupConfigurationFilterInput
  ) {
    listBookingGroupConfigurationByCreatedDate(
      limit: $limit
      nextToken: $nextToken
      sortDirection: DESC
      filter: $filter
      modelName: "BOOKINGGROUPCONFIG"
    ) {
      items {
        modelName
        groupName
        users {
          email
          familyName
          givenName
          name
        }
        groupType
        cidmGroup {
          groupId
          groupName
          cidmUrl
          moreInfoUrl
        }
        siteName
        id
      }
      nextToken
    }
  }
`;
export const LIST_USERS_FILTERS = gql`
  query listAllUsersFilters($limit: Int, $siteName: String) {
    listAllUsersFilters(limit: $limit, siteName: $siteName) {
      id
      userID
      createdBy
      modifiedBy
      assignmentIdentifier
      sharedWithGroups
      filterName
    }
  }
`;
export const LIST_USERS_DISPLAYS = gql`
  query listAllUsersDisplays($limit: Int, $siteName: String) {
    listAllUsersDisplays(limit: $limit, siteName: $siteName) {
      id
      userID
      createdBy
      assignmentIdentifier
      modifiedBy
      sharedWithGroups
      displayName
    }
  }
`;
export const LIST_MY_FILTERS = gql`
  query listUserFiltersByUserID($userID: ID!, $limit: Int) {
    listUserFiltersByUserID(userID: $userID, limit: $limit) {
      id
      userID
      createdBy
      assignmentIdentifier
      modifiedBy
      sharedWithGroups
      filterName
    }
  }
`;
// NOTE: The `triggerAccessConfigurationSync` query was removed here (RETINA-7642175).
// It was a CloudSearch-era, render-time data-repair workaround fired per-row from the
// equipment grid's checkbox cell-renderer. Under OpenSearch the access state is written
// authoritatively by the stream-driven `manageBookableInstruments` backend, and this
// render-time call was actively reverting correct, location-scoped access rules back to
// `isBookingControlled: false`. The backend resolver is kept (deprecated) for ad-hoc
// manual data repair only.

export const LIST_BOOKING_ACCESS_CONFIGURATION_BY_EQUIPMENT_MODEL = gql`
  query listBookingAccessConfigurationByEquipmentModel(
    $limit: Int
    $nextToken: String
    $modelName: String!
    $filter: ModelBookingAccessConfigurationFilterInput
    $equipmentModelName: ModelStringKeyConditionInput
  ) {
    listBookingAccessConfigurationByEquipmentModel(
      limit: $limit
      nextToken: $nextToken
      modelName: $modelName
      filter: $filter
      equipmentModelName: $equipmentModelName
    ) {
      items {
        groupName
        id
        equipmentModelId
        equipmentModelName
        siteName
        location {
          site
          building
          floor
          room
        }
        locationKey
        groups {
          items {
            users {
              email
              name
              familyName
              givenName
            }
            groupType
            cidmGroup {
              groupId
              groupName
              cidmUrl
              moreInfoUrl
            }

          }
        }
        equipment {
          inventoryId
          modelName
          secondaryID
          secondaryIDMapping
          linkedInstance
          siteName
          serialNumber
          materialNumber
          inventoryNumber
          equipmentId
          instrumentRUDI
          instrumentGTIN
          equipmentCategory
          manufacturer
          equipmentModel
          variant
          cluster
          equipmentNickName
          comment
          belongingToGroup
          responsiblePerson
          systemOwner
          responsibleProxy
          functionalLocation
          costCenter
          gxpRelevant
          displayQualificationStatus
          qualificationStatus
          dateOfLastMaintanance
          dateOfNextMaintanance
          softwareVersion
          configurationBaseline
          isBookable
          isVisualized
          systemStatus
          siteId
          siteTimezone
          location
          displayImage
          createdBy
          updatedBy
          status
          datamodelVersion
          shortIdentifier
          addInfoId
          addInfo {
            id
            inventoryId
            instrumentStatus
            instrumentAvailability
            bookedBy
            bookedByEmail
            isBookingControlled
            bookableForUsers
          }
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const LIST_BOOKING_ACCESS_CONFIGURATION_BY_EQUIPMENT = gql`
  query listBookingAccessConfigurationByEquipment(
    $limit: Int
    $nextToken: String
    $modelName: String!
    $filter: ModelBookingAccessConfigurationFilterInput
    $inventoryId: ModelStringKeyConditionInput
  ) {
    listBookingAccessConfigurationByEquipment(
      limit: $limit
      nextToken: $nextToken
      modelName: $modelName
      filter: $filter
      inventoryId: $inventoryId
    ) {
      items {
        groupName
        id
        inventoryId
        siteName
        groups {
          items {
            users {
              email
              name
              familyName
              givenName
            }
            groupType
            cidmGroup {
              groupId
              groupName
              cidmUrl
              moreInfoUrl
            }

          }
        }
        equipment {
          inventoryId
          modelName
          secondaryID
          secondaryIDMapping
          linkedInstance
          siteName
          serialNumber
          materialNumber
          inventoryNumber
          equipmentId
          instrumentRUDI
          instrumentGTIN
          equipmentCategory
          manufacturer
          equipmentModel
          variant
          cluster
          equipmentNickName
          comment
          belongingToGroup
          responsiblePerson
          systemOwner
          responsibleProxy
          functionalLocation
          costCenter
          gxpRelevant
          displayQualificationStatus
          qualificationStatus
          dateOfLastMaintanance
          dateOfNextMaintanance
          softwareVersion
          configurationBaseline
          isBookable
          isVisualized
          systemStatus
          siteId
          siteTimezone
          location
          displayImage
          createdBy
          updatedBy
          status
          datamodelVersion
          shortIdentifier
          addInfoId
          addInfo {
            id
            inventoryId
            instrumentStatus
            instrumentAvailability
            bookedBy
            bookedByEmail
            isBookingControlled
            bookableForUsers
          }
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;

export const LIST_BOOKING_GROUP_CONFIGURATION = gql`
  query listBookingGroupConfigurations($limit: Int, $nextToken: String, $filter: ModelBookingGroupConfigurationFilterInput) {
    listBookingGroupConfigurations(
      limit: $limit
      nextToken: $nextToken
      sortDirection: ASC
      modelName: "BOOKINGGROUPCONFIG"
      filter: $filter
    ) {
      items {
        modelName
        groupName
        users {
          email
          familyName
          givenName
          name
        }
        groupType
        cidmGroup {
          groupId
          groupName
          cidmUrl
          moreInfoUrl
        }
        siteName
        id
      }
      nextToken
    }
  }
`;

export const LIST_BOOKING_GROUP_CONFIGURATION_UNICITY_CHECK = gql`
  query listBookingGroupConfigurationByCreatedDate($filter: String, $nextToken: String) {
    listBookingGroupConfigurationByCreatedDate(
      modelName: "BOOKINGGROUPCONFIG"
      filter: { groupName: { eq: $filter } }
      nextToken: $nextToken
    ) {
      items {
        groupName
        id
      }
      nextToken
    }
  }
`;

export const GET_ELN_EXPERIMENTS = gql`
  query getElnExperiments($searchString: String!, $accessToken: String!) {
    getElnExperiments(searchString: $searchString, accessToken: $accessToken) {
      eid
      type
      name
      owner
      state
      objectType
      modifiedAt
    }
  }
`;

//listDigitalLabLandingPageApplications
export const LP_LIST_DIGITAL_LAB_LANDING_PAGE_APPLICATIONS = gql`
  query listDigitalLabLandingPageApplications {
    listDigitalLabLandingPageApplications {
      items {
        icon
        iconPath
        id
        name
        entryPoints {
          id
          name
          url
        }
      }
    }
  }
`;

export const LP_GET_LOGGED_USER_DETAILS = gql`
  query getLoggedInUserDetails {
    getLoggedInUserDetails(limit: 1) {
      items {
        id
        name
        email
        familyName
        givenName
        user
        lastFilter
        phone
        site
        applicationSets {
          id
          name
          icon
          applicationReferences {
            applicationID
            applicationEntryPointID
          }
        }
        recentApplicationUsage {
          id
          lastUsed
          applicationRef {
            applicationID
            applicationEntryPointID
          }
        }
      }
    }
  }
`;

export const NOTIFICATION_GET_LOGGED_USER_DETAILS = gql`
  query getLoggedInUserDetails {
    getLoggedInUserDetails(limit: 1) {
      items {
        id
        email
        familyName
        givenName
        name
        phone
        site
      }
    }
  }
`;
export const GET_AVAILABLE_PROJECTS = gql`
  query getAvailableProjectsFromRedPanda($userId: String!, $email: String!, $token: String, $projectId: String, $triggerCacheRefresh: Boolean, $timeoutMs: Int) {
    getAvailableProjectsFromRedPanda(userId: $userId, email: $email, token: $token, projectId: $projectId, triggerCacheRefresh: $triggerCacheRefresh, timeoutMs: $timeoutMs) {
      themeNumber
      projectShortName
      projectName
      projectId
    }
  }
`;
export const REPO_GET_DIGITAL_LAB_INSTRUMENT_REPOSITORY_ENTRY = gql`
  query GetDigitalLabInstrumentRepositoryEntry($id: ID!) {
    getDigitalLabInstrumentRepositoryEntry(id: $id) {
      subEquipment {
        items {
          id
          cluster
          clusterId
          equipmentModel
          entryType
          equipmentNickName
          positionInCluster
          qualificationStatus
          softwareVersion
          variant
        }
      }
    }
  }
`;

export const LIST_USER_DISPLAY_COLUMNS = gql`
  query listUserDisplays($userID: ID!) {
    listUserDisplays(userID: $userID) {
      items {
        displayDefinition
        displayName
        id
        userID
      }
    }
  }
`;

export const LIST_SYSTEM_DISPLAY_COLUMNS = gql`
  query listSystemDisplays {
    listSystemDisplays {
      items {
        displayDefinition
        displayName
        id
      }
    }
  }
`;

export const LIST_BOOKING_ACCESS_CONFIG_BY_EQUIP = gql`
  query listBookingAccessConfigurationByEquipment($inventoryId: String!, $limit: Int, $nextToken: String) {
    listBookingAccessConfigurationByEquipment(
      inventoryId: { eq: $inventoryId }
      limit: $limit
      modelName: "BOOKINGACCESSCONFIG"
      nextToken: $nextToken
    ) {
      items {
        id
        inventoryId
        groupName
      }
      nextToken
    }
  }
`;
export const LIST_BOOKING_ACCESS_CONFIG_BY_EQUIP_MODEL = gql`
  query listBookingAccessConfigurationByEquipmentModel($equipmentModelName: ModelStringKeyConditionInput, $limit: Int, $nextToken: String) {
    listBookingAccessConfigurationByEquipmentModel(
      equipmentModelName: { eq: $equipmentModelName }
      limit: $limit
      modelName: "BOOKINGACCESSCONFIG"
      nextToken: $nextToken
    ) {
      items {
        id
        equipmentModelId
        equipmentModelName
        groupName
        locationKey
        location {
          site
          building
          floor
          room
        }
      }
      nextToken
    }
  }
`;

///////////// Repo Graphql /////////////////////////////

export const LIST_IR_CATEGORY_MAPPINGS_MASTER = gql`
  query listIRCategoryMappings($limit: Int, $nextToken: String) {
    listIRCategoryMappings(limit: $limit, nextToken: $nextToken, filter: { isActive: { eq: true } }) {
      nextToken
      items {
        displayImage
        equipmentCategory
        equipmentModel
        variant
        isActive
        manufacturer
        modelName
      }
    }
  }
`;
export const LIST_IR_CLUSTER_CATEGORY_MAPPINGS_MASTER = gql`
  query listIRClusterCategoryMappings($limit: Int, $nextToken: String) {
    listIRClusterCategoryMappings(limit: $limit, nextToken: $nextToken, filter: { isActive: { eq: true } }) {
      nextToken
      items {
        equipmentCategory: clusterCategory
        equipmentModel: clusterModel
        variant
        isActive
        variant
        createdAt
        modifiedById
        modelName
      }
    }
  }
`;
export const LIST_IR_MODEL_MAPPINGS_MASTER = gql`
  query listIRModelMappings($limit: Int, $nextToken: String) {
    listIRModelMappings(limit: $limit, nextToken: $nextToken, filter: { isActive: { eq: true } }) {
      nextToken
      items {
        equipmentModel
        modelName
        variant
      }
    }
  }
`;
export const LIST_IR_LINKED_INSTANCE_MASTER = gql`
  query listSupportedLinkedInstances($limit: Int, $nextToken: String) {
    listSupportedLinkedInstances(limit: $limit, nextToken: $nextToken, filter: { isActive: { eq: true } }) {
      nextToken
      items {
        linkedInstance
        linkedInstanceDisplay
        secondaryIdMapping
      }
    }
  }
`;
export const LIST_IR_GROUP_MASTER = gql`
  query listIRGroupMasters($limit: Int, $nextToken: String) {
    listIRGroupMasters(limit: $limit, nextToken: $nextToken) {
      nextToken
      items {
        value
      }
    }
  }
`;
export const LIST_IR_FILTER_LOOKUPS_MASTER = gql`
  query listIRFilterLookups($limit: Int, $nextToken: String, $field: String) {
    listIRFilterLookups(limit: $limit, nextToken: $nextToken, filterAttribute: $field, sortDirection: ASC) {
      nextToken
      items {
        filterValue
      }
    }
  }
`;
export const LIST_IR_SOP_MASTER = gql`
  query listIRSOPMasters($limit: Int, $nextToken: String) {
    listIRSOPMasters(limit: $limit, nextToken: $nextToken, filter: { isActive: { eq: true } }) {
      nextToken
      items {
        isActive
        key
        value
      }
    }
  }
`;
export const LIST_SITES = gql`
  query listSites($limit: Int, $nextToken: String) {
    listSites(limit: $limit, nextToken: $nextToken) {
      items {
        siteName
      }
      nextToken
    }
  }
`;

export const LIST_LAB_AREAS = gql`
  query getListOfLabAreas {
    listLabAreas {
      items {
        siteName
        areaName
      }
      nextToken
    }
  }
`;

///////////// Repo Graphql /////////////////////////////

///////////// LP Graphql /////////////////////////////
export const LP_GET_LOGGED_USER_DETAILS_USER_FILTERS = gql`
  query getLoggedInUserDetails {
    getLoggedInUserDetails(limit: 1) {
      items {
        id
        name
        email
        userFilters {
          items {
            filterName
            filterDefinition
          }
        }
      }
    }
  }
`;
///////////// BOOKING Graphql /////////////////////////////
export const BOOKING_GET_LOGGED_USER_DETAILS = gql`
  query getLoggedInUserDetails {
    getLoggedInUserDetails(limit: 1) {
      items {
        id
        email
        lastFilter
        familyName
        givenName
        name
        phone
        status
        site
        user
        lastPageSize
        lastDisplayColumns
        searchPreference
        cidmGroups
        userFilters {
          items {
            userID
            filterName
            assignmentIdentifier
            sharedWithGroups
            filterDefinition
          }
        }
        sharedFilters {
          userID
          filterName
          assignmentIdentifier
          sharedWithGroups
          filterDefinition
        }
        sharedDisplays {
          userID
          displayName
          assignmentIdentifier
          sharedWithGroups
          displayDefinition
        }
        groupFilterVisibility
        googleCalendarId
      }
    }
  }
`;

export const GET_DIGITAL_LAB_BOOKING_INSTRUMENTS = gql`
  query getDigitalLabBookingInstrument($inventoryId: String!) {
    getDigitalLabBookingInstrument(inventoryId: $inventoryId) {
      inventoryId
      entryType
      modelName
      secondaryID
      secondaryIDMapping
      controlledEquipmentStatus
      linkedInstance
      siteName
      serialNumber
      materialNumber
      inventoryNumber
      equipmentId
      instrumentRUDI
      instrumentGTIN
      isBookable
      equipmentCategory
      manufacturer
      equipmentModel
      entryType
      variant
      cluster
      clusterId
      equipmentNickName
      comment
      belongingToGroup
      buildingLocation {
        key
        value
      }
      floor {
        key
        value
      }
      room {
        key
        value
      }
      responsiblePerson
      systemOwner
      status
      responsibleProxy
      functionalLocation
      costCenter
      sop {
        key
        value
      }
      gxpRelevant
      qualificationStatus
      dateOfLastMaintanance
      dateOfNextMaintanance
      displayQualificationStatus
      qualificationDocuments {
        isSynchronized
        value {
          name
          documentId
        }
      }
      softwareVersion
      configurationBaseline
      configurationDetails
      vnvStatus
      installedTests {
        name
        version
      }
      isBookable
      isHazardous
      assistedBooking
      isVisualized
      systemStatus
      siteId
      siteTimezone
      location
      displayImage
      createdBy
      updatedBy
      status
      datamodelVersion
      shortIdentifier
      addInfoId
      createdAt
      updatedAt
      addInfo {
        id
        inventoryId
        instrumentStatus
        instrumentAvailability
        bookedBy
        bookedByEmail
        isBookingControlled
        bookableForUsers
      }
    }
  }
`;
export const GET_BOOKING_ENTRIES_BY_SITE_AND_INVENTORY_ID = gql`
  query bookingEntriesBySiteAndInventoryId(
    $site: String
    $inventoryId: ModelStringKeyConditionInput
    $filter: ModelBookingEntriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingEntriesBySiteAndInventoryId(
      inventoryId: $inventoryId
      site: $site
      limit: $limit
      nextToken: $nextToken
      filter: $filter
    ) {
      items {
        active
        isFirstTimeUser
        allDay
        bookingId
        color
        createdAt
        createdBy
        createdByEmail
        date
        description
        richDescription
        elnId {
          name
          eid
          modifiedAt
          objectType
          owner
          state
          type
        }
        end
        equipment {
          addInfo {
            bookableForUsers
            bookedBy
            bookedByEmail
            id
            instrumentAvailability
            instrumentStatus
            inventoryId
            isBookingControlled
          }
          addInfoId
          belongingToGroup
          cluster
          clusterId
          configurationBaseline
          costCenter
          controlledEquipmentStatus
          createdAt
          createdBy
          datamodelVersion
          dateOfLastMaintanance
          dateOfNextMaintanance
          displayImage
          displayQualificationStatus
          entryType
          equipmentCategory
          equipmentId
          equipmentModel
          equipmentNickName
          instrumentRUDI
          instrumentGTIN
          inventoryNumber
          inventoryId
          isBookable
          isHazardous
          assistedBooking
          isVisualized
          manufacturer
          materialNumber
          modelName
          siteName
          siteId
          shortIdentifier
          secondaryIDMapping
          secondaryID
          serialNumber
          location
          responsiblePerson
          softwareVersion
          systemStatus
          variant
        }
        bookingApprovalInfo {
          assistent
          checkInDone
          assistentTime
          checkInRequired
          checkInEndsAt
          hazardousDeclaration {
            hasHazardousMaterials
            hazardousMaterialsList
          }
          checkInStartsAt
          type
          active
          approval {
            approvalType
            approvedBy
            approvedByEmail
            approvedDate
            rejectionReason
            status
          }
          assistanceDeclaration {
            assistanceReason
            requiresAssistance
          }
        }
        expiresAt
        fcolor
        id
        project
        redPandaProjects {
          themeNumber
          projectShortName
          projectName
          projectId
        }
        reservedForEmails
        resource
        site
        start
        timezone
        type
        parentBookingCommandId
        occurrenceIndex
        repetitionPattern
      }
      nextToken
    }
  }
`;
export const GET_BOOKING_ENTRIES_BY_SITE_AND_DATE = gql`
  query bookingEntriesBySiteAndDate(
    $site: String
    $limit: Int
    $nextToken: String
    $filter: ModelBookingEntriesFilterInput
    $sortDirection: ModelSortDirection
    $date: ModelStringKeyConditionInput
  ) {
    bookingEntriesBySiteAndDate(
      site: $site
      limit: $limit
      nextToken: $nextToken
      filter: $filter
      sortDirection: $sortDirection
      date: $date
    ) {
      items {
        active
        allDay
        bookingId
        color
        createdAt
        createdBy
        createdByEmail
        date
        description
        richDescription
        end
        equipment {
          addInfo {
            bookableForUsers
            bookedBy
            bookedByEmail
            id
            instrumentAvailability
            instrumentStatus
            inventoryId
            isBookingControlled
          }
          addInfoId
          belongingToGroup
          cluster
          configurationBaseline
          costCenter
          controlledEquipmentStatus
          createdAt
          createdBy
          datamodelVersion
          dateOfLastMaintanance
          dateOfNextMaintanance
          displayImage
          displayQualificationStatus
          entryType
          equipmentCategory
          equipmentId
          equipmentModel
          equipmentNickName
          instrumentRUDI
          instrumentGTIN
          inventoryNumber
          inventoryId
          isBookable
          isVisualized
          manufacturer
          materialNumber
          modelName
          siteName
          siteId
          shortIdentifier
          secondaryIDMapping
          secondaryID
          serialNumber
          location
          responsiblePerson
          softwareVersion
          systemStatus
          variant
        }
        expiresAt
        fcolor
        id
        project
        redPandaProjects {
          themeNumber
          projectShortName
          projectName
          projectId
        }
        reservedForEmails
        resource
        site
        start
        timezone
        type
      }
      nextToken
    }
  }
`;
export const GET_BOOKING_ENTRIES_BY_BOOKING_ID = gql`
  query bookingEntriesByBookingId($bookingId: ID, $nextToken: String, $filter: ModelBookingEntriesFilterInput) {
    bookingEntriesByBookingId(bookingId: $bookingId, nextToken: $nextToken, filter: $filter) {
      items {
        active
        allDay
        bookingId
        color
        createdAt
        createdBy
        createdByEmail
        date
        description
        richDescription
        elnId {
          name
          eid
          modifiedAt
          objectType
          owner
          state
          type
        }
        end
        equipment {
          addInfo {
            bookableForUsers
            bookedBy
            bookedByEmail
            id
            instrumentAvailability
            instrumentStatus
            inventoryId
            isBookingControlled
          }
          addInfoId
          belongingToGroup
          cluster
          configurationBaseline
          costCenter
          controlledEquipmentStatus
          createdAt
          createdBy
          datamodelVersion
          dateOfLastMaintanance
          dateOfNextMaintanance
          displayImage
          displayQualificationStatus
          entryType
          equipmentCategory
          equipmentId
          equipmentModel
          equipmentNickName
          instrumentRUDI
          instrumentGTIN
          inventoryNumber
          inventoryId
          isBookable
          isHazardous
          assistedBooking
          isVisualized
          manufacturer
          materialNumber
          modelName
          siteName
          siteId
          shortIdentifier
          secondaryIDMapping
          secondaryID
          serialNumber
          location
          responsiblePerson
          softwareVersion
          systemStatus
          variant
        }
        bookingApprovalInfo {
          assistent
          checkInDone
          assistentTime
          checkInRequired
          checkInEndsAt
          hazardousDeclaration {
            hasHazardousMaterials
            hazardousMaterialsList
          }
          checkInStartsAt
          type
          active
          approval {
            approvalType
            approvedBy
            approvedByEmail
            approvedDate
            rejectionReason
            status
          }
          assistanceDeclaration {
            assistanceReason
            requiresAssistance
          }
        }
        expiresAt
        fcolor
        id
        project
        redPandaProjects {
          themeNumber
          projectShortName
          projectName
          projectId
        }
        reservedForEmails
        resource
        site
        start
        timezone
        type
      }
      nextToken
    }
  }
`;
export const GET_SITE_TIMEZONE = gql`
  query getSite($siteName: String!) {
    getSite(siteName: $siteName) {
      siteName
      timezone
    }
  }
`;

export const GET_LIST_OF_ACTION_TYPES = gql`
  query listActionTypes {
    __type(name: "ActionTypes") {
      enumValues {
        name
      }
    }
  }
`;

export const LIST_BUILDINGS = gql`
  query listBuildings($siteName: String, $limit: Int, $nextToken: String) {
    listBuildings(siteName: $siteName, limit: $limit, nextToken: $nextToken) {
      items {
        name
        id
      }
      nextToken
    }
  }
`;


export const GET_SITE = gql`
  query getSite(
    $modelName: String!
    $siteName: String!
  ) {
    getSite(
      modelName: $modelName
      siteName: $siteName
    ) {
      siteId
    }
  }
`;

export const LST_BUILDINGS_BY_SITEID_AND_BUILDING_NUMBER = gql`
  query listBuildingBySiteIdAndBuildingNumber(
    $siteId: String
    $buildingNumber: ModelStringKeyConditionInput
    $filter: ModelIRBuildingMasterFilterInput
  ) {
    listBuildingBySiteIdAndBuildingNumber(
      siteId: $siteId
      buildingNumber: $buildingNumber
      filter: $filter
    ) {
      items {
        id
        siteId
        buildingId
        buildingNumber
      }
    }
  }
`;

export const LIST_FLOOR_BY_BUILDINGS_ID_AND_FLOOR_CODE = gql`
  query listFloorByBuildingsIdAndFloorCode(
    $buildingsId: Int
    $floorCode: ModelStringKeyConditionInput
    $filter: ModelIRFloorMasterFilterInput
  ) {
    listFloorByBuildingsIdAndFloorCode(
      buildingsId: $buildingsId
      floorCode: $floorCode
      filter: $filter
    ) {
      items {
        id
        floorId
        floorCode
        buildingsId
        buildingId
      }
    }
  }
`;

export const LIST_ROOM_BY_FLOORS_ID_AND_ROOM_CODE = gql`
  query listRoomByFloorsIdAndRoomCode(
    $floorsId: Int
    $roomCode: ModelStringKeyConditionInput
    $filter: ModelIRRoomMasterFilterInput
  ) {
    listRoomByFloorsIdAndRoomCode(
      floorsId: $floorsId
      roomCode: $roomCode
      filter: $filter
    ) {
      items {
        id
        roomId
        roomCode
        floorsId
        floorId
      }
    }
  }
`;

export const INFORMATION_BOOKINGS_BY_SITE = gql`
  query informationBookingsBySite(
    $site: String!
    $dateFrom: AWSDateTime!
    $dateTo: AWSDateTime!
    $limit: Int
    $nextToken: String
  ) {
    informationBookingsBySite(
      site: $site
      dateFrom: $dateFrom
      dateTo: $dateTo
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        batchId
        description
        richDescription
        reservedForUsers
        project
        redPandaProjects {
          projectId
          projectName
          projectShortName
          themeNumber
        }
        dateFrom
        dateTo
        date
        site
        inventoryId
        color
        fcolor
        active
        createdBy
        createdByEmail
        updatedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

// Returns active slot ids belonging to a batch (KEYS_ONLY GSI lookup, limit
// 100). FE uses it as the first step of batch update / batch delete cascade.
// ISO 7367645.
export const INFORMATION_BOOKING_IDS_BY_BATCH_ID = gql`
  query informationBookingIdsByBatchId($batchId: ID!) {
    informationBookingIdsByBatchId(batchId: $batchId)
  }
`;

export const GET_INFORMATION_BOOKING = gql`
  query getInformationBooking($id: ID!) {
    getInformationBooking(id: $id) {
      id
      batchId
      description
      richDescription
      reservedForUsers
      project
      redPandaProjects {
        projectId
        projectName
        projectShortName
        themeNumber
      }
      dateFrom
      dateTo
      date
      site
      inventoryId
      color
      fcolor
      active
      createdBy
      createdByEmail
      updatedBy
      createdAt
      updatedAt
    }
  }
`;


export const listIRAliasLookups = gql`
  query listIRAliasLookups(
    $filter: ModelIRAliasLookupFilterInput
    $nextToken: String
  ) {
    listIRAliasLookups(
      filter: $filter
      nextToken: $nextToken
    ) {
      nextToken
      items {
        alias
        modelName
        actualName
      }
    }
  }
`;

export const LIST_NOTIFICATION_BANNER = gql`
  query listNotificationActiveBookingBanners($nextToken: String) {
    listNotificationActiveBookingBanners(nextToken: $nextToken) {
      id
      heading
      displayText
      infoURL
      userId
      cidmGroupName
      from
      to
      site
      color
      app
      createdAt
      updatedAt
    }
  }
`;

export const LIST_IR_GROUP_ADMIN_MAPPINGS = gql`
  query listIRGroupAdminMappings($limit: Int, $nextToken: String) {
    listIRGroupAdminMappings(
      limit: $limit
      nextToken: $nextToken
      modelName: "IRGroupAdminMapping"
    ) {
      items {
        groupName
        userIds {
          email
          familyName
          givenName
          name
          userId
        }
        reviewers {
          email
          familyName
          givenName
          name
          userId
        }
      }
      nextToken
    }
  }
`;
